import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import StarRating from "react-star-ratings";
import EditIcon from "../../assets/images/edit-icon.png";
import { Button } from "../Button/Button.jsx";
import classes from "./MobileConfirmBookingLessonCard.module.css";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import {
  CalendarIconGray,
  coachDemoImg,
  LocationIconGray,
  ClockIconGray,
  ApplePayBlack,
  EditIconGray,
  ApplePayDisabled,
} from "../../constant/imagePath";
import { ReactSVG } from "react-svg";

export const MobileConfirmBookingLessonCard = ({
  data,
  disabled,
  onClickApplePay,
  onClickProceedWithPayment,
  setIsErrorOccurenceModalOpen,
  setIsCancellationModalOpen,
  setIsRequirementsModalOpen,
  setIsBookingRequestedModalOpen,
}) => {
  return (
    <div
      className={`${[classes.lessonCard].join(" ")}`}
      // style={{ boxShadow: `0px 4px 27px ${Colors.boxShadow}` }}
    >
      <Row className="g-0">
        <Col md={12} className="d-flex">
          <div>
            <img
              src={data?.userData?.photo}
              className={`${[classes.profile].join(" ")}`}
            />
          </div>
          <div className={classes.headingWithRatingAndReviews}>
            <h5 className={classes.mainHeading}>
              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}>
                {data?.userData?.displayName?.split(" ")[0]}
              </span>
              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}>
                {data?.userData?.displayName?.split(" ")[1]}
              </span>
            </h5>
            <div className={` ${[classes.userDetails].join(" ")}`}>
              <p className={classes.ratingStar}>
                <StarRating
                  starRatedColor={Colors.mainShadeOfRed}
                  starEmptyColor={Colors.neutralShadesOfDimGray}
                  rating={data?.userData?.rating / 5}
                  starDimension={"16px"}
                  numberOfStars={1}
                />
              </p>
              <span
                className={`${[classes.rating].join(" ")}`}
                style={{
                  color: Colors.neutralShadesOfNero,
                  ...Fonts.p2,
                  fontFamily: "inter-600",
                }}
              >
                {data?.userData.rating?.toFixed(1)}
              </span>
              <a
                className={`${[classes.reviews].join(" ")}`}
                style={{ color: Colors.neutralShadesOfDimGray, ...Fonts.p2 }}
              >
                ({data?.userData?.reviews?.length} reviews)
              </a>
              <span
                className={`${[classes.break].join(" ")}`}
                style={{
                  backgroundColor: Colors.neutralShadesOfPinkSwan,
                }}
              />

              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.h9 }}>
                {data?.userData.sport}
              </span>
            </div>
          </div>
        </Col>

        <Col
          md={12}
          className={`${[classes.borderBottom].join(" ")}`}
          style={{
            borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
        />
        {/* Lesson Details */}
        <Col md={12}>
          <div className={`${[classes.headingAndText].join(" ")}`}>
            <h5 style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}>
              Lesson details
            </h5>
            <span>
              <ReactSVG
                src={EditIconGray}
                beforeInjection={(svg) => {
                  svg.classList.add(classes.editIcon);
                }}
                onClick={() => setIsCancellationModalOpen(true)}
              />
            </span>
          </div>
        </Col>
        <Col md={12}>
          <ul className={`${[classes.lessonDetails]}`}>
            <li>
              <ReactSVG src={CalendarIconGray} />
              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.p1 }}>
                {data?.date}
              </span>
            </li>
            <li>
              <ReactSVG src={ClockIconGray} />
              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.p1 }}>
                {data?.startTime} - {data?.endTime}
              </span>
            </li>
            <li>
              <ReactSVG src={LocationIconGray} />
              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.p1 }}>
                {data?.location}
              </span>
            </li>
          </ul>
        </Col>
        <Col
          md={12}
          className={`${[classes.borderBottom].join(" ")}`}
          style={{
            borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
        />
      </Row>
    </div>
  );
};

MobileConfirmBookingLessonCard.propTypes = {
  data: PropTypes.object,
  disabled: PropTypes.bool,
  onClickApplePay: PropTypes.func,
  onClickProceedWithPayment: PropTypes.func,
};
MobileConfirmBookingLessonCard.defaultProps = {
  data: {
    userData: {
      displayName: "Micheal Baumgardner",
      photo: coachDemoImg,
      rating: 5,
      sport: "Tennis coach",
      reviews: [{}, {}, {}, {}, {}, {}, {}],
    },
    price: 85,
    date: "Aug 12, 2021",
    startTime: "12:30PM",
    endTime: "2:30PM",
    location: "DeWitt Clinton Park, W 54th St, New York, NY",
  },
  disabled: false,
  onClickApplePay: () => {},
  onClickProceedWithPayment: () => {},
};
